/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/* eslint-env browser */

import template from './clock-root.html';

export default {
  name: 'ClockRoot',
  template,
  created() {
    this.interval = setInterval(this.refresh, this.delay);
    this.refresh();
  },
  data() {
    return {
      value: null
    };
  },
  destroyed() {
    clearInterval(this.interval);
  },
  methods: {
    refresh() {
      const now = new Date();
      const hours = String(now.getHours());
      const minutes = String(now.getMinutes()).padStart(2, '0');
      this.value = `${hours}:${minutes}`;
    }
  },
  props: {
    delay: {
      type: Number,
      required: true
    }
  }
};
